import { applySpec, pathOr, propOr, pipe, values, join, head, map } from 'ramda'
import { createSelector } from 'reselect'
import { isNotEmpty } from 'utils/ramda'

const getAuthState = state => state.auth

export const getCurrentUser = createSelector(
  getAuthState,
  propOr({}, 'user')
)

export const selectCurrentInvitation = createSelector(
  getAuthState,
  propOr({}, 'currentInvitation')
)

export const getCurrentUserName = createSelector(
  getAuthState,
  state => pipe(
    applySpec({
      firstName: pathOr('', ['user', 'firstName']),
      lastName: pathOr('', ['user', 'lastName'])
    }),
    values,
    join(' ')
  )(state)
)

export const getCurrentUserInitials = createSelector(
  getAuthState,
  state => pipe(
    applySpec({
      firstName: pathOr('', ['user', 'firstName']),
      lastName: pathOr('', ['user', 'lastName'])
    }),
    values,
    map(head),
    join('')
  )(state)
)

export const getUserFirstName = createSelector(
  getAuthState,
  pathOr('', ['user', 'firstName'])
)

export const getUserPhotoUrl = createSelector(
  getAuthState,
  pathOr(null, ['user', 'avatar'])
)

export const getCurrentUserRole = createSelector(
  getAuthState,
  pathOr('', ['user', 'type'])
)

export const selectAccreditationTypes = createSelector(
  getAuthState,
  propOr([], 'accreditations')
)

export const selectPublicApiToken = createSelector(
  getAuthState,
  propOr(null, 'publicApiToken')
)

export const selectTwoFactorChallenge = createSelector(
  getAuthState,
  propOr(null, 'twoFactorChallenge')
)

export const selectTwoFactorStatus = createSelector(
  getAuthState,
  propOr(null, 'twoFactorStatus')
)

export const selectTwoFactorSetup = createSelector(
  getAuthState,
  propOr(null, 'twoFactorSetup')
)

export const isUserLoggedIn = createSelector(
  getCurrentUser,
  isNotEmpty
)

export const selectHasAnyTaskManagementBp = createSelector(
  getAuthState,
  pathOr(false, ['user', 'hasAnyTaskManagementBp'])
)

export const selectHasPortfoliosAccess = createSelector(
  getAuthState,
  () => true
)

export const selectPersona = createSelector(getAuthState, pathOr(null, ['user', 'persona']))

export const selectAuthLoading = createSelector(getAuthState, pathOr(false, ['isLoading']))

export const selectComplianceEnabled = createSelector(
  getAuthState,
  state => {
    const feature = pathOr(undefined, ['user', 'featureVisibility', 'compliance'], state)
    if (feature === false) return false
    if (feature === true) return true
    const persona = pathOr(null, ['user', 'persona'], state)
    if (persona !== null) return persona !== 'team_member'
    return pathOr(true, ['user', 'complianceEnabled'], state)
  },
)

export const selectPortfolioZoomLevel = createSelector(
  getAuthState,
  pathOr(null, ['user', 'portfolioZoomLevel'])
)

export const selectFeatureVisibility = createSelector(
  getAuthState,
  pathOr(null, ['user', 'featureVisibility'])
)

export const selectFeatureDefaultOwner = createSelector(
  getAuthState,
  (auth) => {
    const persona = pathOr(null, ['user', 'persona'], auth)
    if (persona === 'team_member') return false
    if (persona !== null) return true
    return pathOr(undefined, ['user', 'ownsAnyBp'], auth)
  }
)
